var map = {
	"./Armorer1.png": "8808",
	"./Armorer2.png": "f2ca",
	"./BigGuns1.png": "a522",
	"./BigGuns2.png": "0e4a",
	"./DemolitionExpert1.png": "d787",
	"./DemolitionExpert2.png": "9d19",
	"./Doctor1.png": "0982",
	"./Doctor2.png": "fdfb",
	"./EnergyExpert1.png": "d2a1",
	"./EnergyExpert2.png": "c9f9",
	"./SmallGuns1.png": "2ac4",
	"./SmallGuns2.png": "6eed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d889";